const childrenLoaded = require("@alexspirgel/children-loaded");

class ResourceList extends ESWPPostList {

	constructor() {
		super();
	}

	static setQueryStrings(queryStrings) {
		const searchParams = new URLSearchParams(window.location.search);
		for (const key in queryStrings) {
			const value = queryStrings[key];
			if (value === false
				|| (key === 'page' && (value === 1 || value === '1'))) {
				searchParams.delete(key);
			}
			else {
				searchParams.set(key, value);
			}
		}
		const newURL = new URL(window.location.href);
		newURL.search = searchParams.toString();
		window.history.replaceState({path: newURL.href}, '', newURL.href);
	}

	async connectedCallback() {
		await childrenLoaded(this);
		if (this.queryStringFiltering) {
			this.queryStrings = this.constructor.getQueryStrings();
			const queryStringsTermIds = this.queryStringSlugsToTermIds(this.queryStrings);
			this.setFormValues(queryStringsTermIds);

		}
		this.formAttachEventListeners();
		this.addUpdateTemplateElementCallback("form",this.formAttachEventListeners);
		this.formOnChangeListener();
		this.paginationAttachEventListeners();
		this.addUpdateTemplateElementCallback('pagination', this.paginationAttachEventListeners);
	}

	get queryStringFiltering() {
		const queryStringFilteringAttribute =  this.getAttribute('data-query-string-filtering');
		if (!this.constructor.isAdmin() && queryStringFilteringAttribute == 'true') {
			return true;
		}
		else {
			return false;
		}
	}

	queryStringSlugsToTermIds(formData) {
		formData = Object.assign({}, formData);
		if (typeof formData['resource_type'] === 'string' && formData['resource_type'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#resource_type option[data-slug="${formData['resource_type']}"]`);
			if (optionElement) {
				formData['resource_type'] = optionElement.getAttribute('value');
			}
		}
		if (typeof formData['resource_topic'] === 'string' && formData['resource_topic'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#resource_subject option[data-slug="${formData['resource_subject']}"]`);
			if (optionElement) {
				formData['resource_topic'] = optionElement.getAttribute('value');
			}
		}
		if (typeof formData['author'] === 'string' && formData['author'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#author option[data-slug="${formData['author']}"]`);
			if (optionElement) {
				formData['author'] = optionElement.getAttribute('value');
			}
		}
		if (typeof formData['resource_genre'] === 'string' && formData['resource_genre'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#resource_genre option[data-slug="${formData['resource_genre']}"]`);
			if (optionElement) {
				formData['resource_genre'] = optionElement.getAttribute('value');
			}
		}
		if (typeof formData['issue_type'] === 'string' && formData['issue_type'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#issue_type option[data-slug="${formData['issue_type']}"]`);
			if (optionElement) {
				formData['issue_type'] = optionElement.getAttribute('value');
			}
		}

		return formData;
	}

	formDataTermIdsToSlugs(formData) {
		formData = Object.assign({}, formData);
		if (typeof formData['resource_type'] === 'string' && formData['resource_type'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#resource_type option[value="${formData['resource_type']}"]`);
			if (optionElement) {
				formData['resource_type'] = optionElement.getAttribute('data-slug');
			}
		}
		if (typeof formData['resource_topic'] === 'string' && formData['resource_topic'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#resource_subject option[value="${formData['resource_subject']}"]`);
			if (optionElement) {
				formData['resource_topic'] = optionElement.getAttribute('data-slug');
			}
		}
		if (typeof formData['author'] === 'string' && formData['author'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#author option[value="${formData['author']}"]`);
			if (optionElement) {
				formData['author'] = optionElement.getAttribute('data-slug');
			}
		}
		if (typeof formData['resource_genre'] === 'string' && formData['resource_genre'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#resource_genre option[value="${formData['resource_genre']}"]`);
			if (optionElement) {
				formData['resource_genre'] = optionElement.getAttribute('data-slug');
			}
		}
		if (typeof formData['issue_type'] === 'string' && formData['issue_type'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#issue_type option[value="${formData['issue_type']}"]`);
			if (optionElement) {
				formData['issue_type'] = optionElement.getAttribute('data-slug');
			}
		}
		return formData;
	}
	
	paginationAttachEventListeners = () => {
		const pagerButtonElements = this.templateElements.pagination.querySelectorAll('button');
		for (let buttonElement of pagerButtonElements) {
			buttonElement.addEventListener('click', this.paginationButtonClickHandler);
		}
	}

	getFormValues() {
		return this.constructor.getFormValues(this.templateElements.form);
	}

	setFormValues(values) {
		return this.constructor.setFormValues(this.templateElements.form, values);
	}

	formAttachEventListeners = () => {
		this.templateElements.form.addEventListener('submit', this.formSubmitHandler);
	};

	formSubmitHandler = (event) => {
		if (event.preventDefault) {
			event.preventDefault();
		}
		this.submitForm();
    return false;
	};

	formOnChangeListener = () => {
		const selects = this.templateElements.form.querySelectorAll('select');

		if (!selects.length) {
			return;
		}

		for (let select of selects) {
			select.addEventListener('customFilterChange', (e) => {
				e.stopPropagation();
				this.formSubmitHandler(e);
			});
		}
	};


	async submitForm(page = 1) {
		const formData = this.getFormValues();
		formData['archive_id'] = this.getAttribute('data-archive-id');
		const args = {
			key: this.key,
			templates: ['results', 'pagination'],
			request_data: formData,
			page: page,
		};
		const formDataSlugs = this.formDataTermIdsToSlugs(formData);
		// if (this.queryStringFiltering) {
		// 	for (const name in formDataSlugs) {
		// 		if (formDataSlugs[name] === '') {
		// 			formDataSlugs[name] = false;
		// 		}
		// 	}
		// 	formDataSlugs['page'] = page;
		// 	this.constructor.setQueryStrings(formDataSlugs);
		// }
		const newTemplates = await this.fetchTemplates(args);
		this.updateTemplateElement('results', newTemplates.results);
		this.updateTemplateElement('pagination', newTemplates.pagination);
	}

	paginationButtonClickHandler = async (event) => {
		const page = event.target.getAttribute('data-page');
		await this.appendPage(page);
	}

	async getPage(page) {
		const isArchive = this.templateElements.form.getAttribute('data-is-archive');
		const archivePost = this.getAttribute('data-archive-id');
		const formData = this.getFormValues();
		const args = {
			key: this.key,
			templates: ['results', 'pagination'],
			request_data: {'is_archive': isArchive, 'archive_id' : archivePost, 'page': page, ... formData},
			page: page
		};
		const newTemplates = await this.fetchTemplates(args);
		return newTemplates;
	}

	async goToPage(page) {
		const newTemplates = await this.getPage(page);
		this.updateTemplateElement('results', newTemplates.results);
		this.updateTemplateElement('pagination', newTemplates.pagination);
	}

	async appendPage(page) {
		const newTemplates = await this.getPage(page);
		const resultsContainer = this.querySelector(
			'[data-post-list-template="results"]'
		);
		const htmlObject = document.createElement("div");
		htmlObject.innerHTML = newTemplates.results;
		const newResultsItems = htmlObject.querySelectorAll(
			'[data-post-list-template="results"] > li'
		);
		for (const newResultsItem of newResultsItems) {
			resultsContainer.append(newResultsItem);
		}
		this.updateTemplateElement("pagination", newTemplates.pagination);
	}

}

document.addEventListener('DOMContentLoaded', () => {
	customElements.define('post-list-resource-list', ResourceList, {extends: 'div'});
});
